import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import CheckboxRadio from 'common/CheckboxRadio';

const baseString = 'vra-seed-product-results-list-cell';
const SeedProductResultsListCell = ({
  cellWidth,
  dataKey,
  rowData
}) => {
  const { isDisabled, isSelected, onSelect } = rowData;

  var classString = classNames({
    [`${baseString}`]: true,
    'isSelected': isSelected,
    'isDisabled': isDisabled
  });
  
  const content = dataKey === 'brand'
    ? (
      <CheckboxRadio
        dataTestId={baseString}
        disabled={isDisabled}
        isChecked={isSelected}
        labelText={rowData[dataKey]}
        onChange={() => onSelect(rowData)}
        type='checkbox'
      />
    )
    : rowData[dataKey];
 
  return (
    <div className={classString} style={{width: cellWidth}}>
      {content}
    </div>
  );

};
SeedProductResultsListCell.propTypes = {
  cellWidth: propTypes.number,
  dataKey: propTypes.number.isRequired,
  rowData: propTypes.object.isRequired
};
export default SeedProductResultsListCell;
